/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

(function () {
  'use strict';

  function initPrScrollDots() {
    document.querySelectorAll('.pr-scroll').forEach(function (scroll) {
      var cards = scroll.querySelectorAll('.pcc');
      if (cards.length <= 1) return;

      var dotsWrapper = document.createElement('div');
      dotsWrapper.className = 'pr-dots';

      cards.forEach(function (_, i) {
        var dot = document.createElement('button');
        dot.className = 'pr-dot' + (i === 0 ? ' pr-dot--active' : '');
        dot.setAttribute('aria-label', 'Aller au produit ' + (i + 1));
        dot.addEventListener('click', function () {
          scroll.scrollTo({ left: cards[i].offsetLeft - scroll.offsetLeft, behavior: 'smooth' });
        });
        dotsWrapper.appendChild(dot);
      });

      scroll.parentNode.insertBefore(dotsWrapper, scroll.nextSibling);

      scroll.addEventListener('scroll', function () {
        var center = scroll.scrollLeft + scroll.clientWidth / 2;
        var closest = 0;
        var minDist = Infinity;
        cards.forEach(function (card, i) {
          var cardCenter = card.offsetLeft - scroll.offsetLeft + card.offsetWidth / 2;
          var dist = Math.abs(center - cardCenter);
          if (dist < minDist) { minDist = dist; closest = i; }
        });
        dotsWrapper.querySelectorAll('.pr-dot').forEach(function (d, i) {
          d.classList.toggle('pr-dot--active', i === closest);
        });
      }, { passive: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPrScrollDots);
  } else {
    initPrScrollDots();
  }
})();
